import React from "react";
import { Label } from "reactstrap";
import Select from "react-select";
import Required from "./Required";
import { handleStatusChange } from "../../../utils/Utils";
import MyLabel from "./MyLabel";

const Status = ({ title,register, watch, errors, setValue, trigger,required }) => {
  return (
    <div className="form-group my-2">
      <MyLabel name={"status"} title={title} required={required}/>
      <div className="form-control-wrap">
        <Select
          className=""
          id="status"
          options={[
            { value: true, label: "Active" },
            { value: false, label: "InActive" },
          ]}
          {...register("status", {
            required: "Please select status",
          })}
          onChange={(e) => handleStatusChange(setValue, e, trigger)}
          value={watch("status")}
        />
        {errors.status && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {errors?.status?.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default Status;
